import {
  Injectable,
  QueryList,
  Renderer2,
  RendererFactory2,
} from "@angular/core";
import { MatLegacyMenuTrigger } from "@angular/material/legacy-menu";
import { Subscription } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MenuTriggerService {
  private currentMenuTrigger: MatLegacyMenuTrigger;
  private lastMenuTrigger: MatLegacyMenuTrigger;
  private isFirstOpen = false;
  private subscriptions: { [key: string]: Subscription[] } = {};
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.listenForScroll();
  }

  afterViewInit(
    menuTriggers: QueryList<MatLegacyMenuTrigger>,
    actionsCollection: string = "actions"
  ) {
    menuTriggers.changes.subscribe(() => {
      this.subscribeToEvent(menuTriggers, actionsCollection);
    });

    if (menuTriggers.length !== 0) {
      this.subscribeToEvent(menuTriggers, actionsCollection);
    }
  }

  unsubscribeFromAction(actionsCollection: string = "actions") {
    if (this.subscriptions[actionsCollection]) {
      this.unsubscribe(actionsCollection);
    }
  }

  listenForScroll() {
    this.renderer.listen("window", "scroll", (evt) => {
      this.closeActiveMenu();
    });
  }

  documentEvent(event) {
    if (
      document.querySelector(".actions-list") &&
      !document.querySelector(".actions-list").contains(event.target as Node)
    ) {
      if (this.lastMenuTrigger && this.lastMenuTrigger.closeMenu) {
        this.lastMenuTrigger.closeMenu();
        this.lastMenuTrigger = null;
        return;
      }

      if (
        !this.isFirstOpen &&
        this.currentMenuTrigger &&
        this.currentMenuTrigger.closeMenu
      ) {
        this.currentMenuTrigger.closeMenu();
        this.currentMenuTrigger = null;
        this.renderer.removeClass(document.body, "menu-opened");
      }

      this.isFirstOpen = false;
    } else {
      this.currentMenuTrigger = null;
      this.renderer.removeClass(document.body, "menu-opened");
    }
  }

  closeActiveMenu() {
    if (this.currentMenuTrigger) {
      this.currentMenuTrigger.closeMenu();
      this.currentMenuTrigger = null;
      this.renderer.removeClass(document.body, "menu-opened");
    }
  }

  private unsubscribe(actionsCollection) {
    if (this.subscriptions[actionsCollection].length !== 0) {
      this.subscriptions[actionsCollection].forEach((s) => s.unsubscribe());
      this.subscriptions[actionsCollection] = [];
    }

    return this.subscriptions[actionsCollection];
  }

  private subscribeToEvent(menuTriggers, actionsCollection) {
    if (!this.subscriptions[actionsCollection]) {
      this.subscriptions[actionsCollection] = [];
    }

    const currentSubscriptions = this.unsubscribe(actionsCollection);

    menuTriggers.forEach((menuTrigger) => {
      currentSubscriptions.push(
        menuTrigger.menuOpened.subscribe(() => {
          this.isFirstOpen = !this.currentMenuTrigger;
          this.lastMenuTrigger = this.currentMenuTrigger;
          this.currentMenuTrigger = menuTrigger;
          if (this.currentMenuTrigger) {
            this.renderer.addClass(document.body, "menu-opened");
          }
        })
      );
    });
  }
}
